import { Box, Button, Grid, IconButton, Paper, Tooltip, TextField, Typography, useTheme } from "@mui/material";
import { FaArrowRight, FaPlay } from "react-icons/fa";
import { RiLoopLeftLine } from "react-icons/ri";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { getTimestampFromDuration } from "../utils/timestampUtils";
import { ThemeProvider} from '@mui/material/styles';
import ColorButton from "../ColorButton"
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { NodeHtmlMarkdown } from 'node-html-markdown';

import DeleteIcon from '@mui/icons-material/Delete';
import MDEditor from '@uiw/react-md-editor/nohighlight'
import { useState, useRef, useEffect } from "react";
import { updateBookmarks, updateSection, indexForNextOfType, updateTimestamp } from "./bookmarks";


function StartTabButton({index, handleStartClick}) {
  const theme = useTheme();
  return (
    <>
    <Tooltip title="Start the section again" size="md" arrow>
        <IconButton onClick={(e) => {
          e.preventDefault();
          handleStartClick(index)}}
          variant="contained"
          style={{ 
            // backgroundColor: theme.palette.primary.main,
            width: '35px', // Ensures the button is square-shaped
            height: '35px', // Height equal to the desired width to make it square
          }}
        >
          <FaPlay size={20}/>
        </IconButton>
      </Tooltip>
    </>
  );
}

function LoopTabButton({index, handleLoopClick}) {
  const theme = useTheme();
  return (
    <>
    <Tooltip title="Continuosly repeat the section again and again until unloop button is clicked" size="md" arrow>
      <IconButton onClick={(e) => {
        e.preventDefault();
        handleLoopClick(index);}}
        variant="contained"
        style={{ 
        //   backgroundColor: theme.palette.primary.main,
          width: '35px', // Ensures the button is square-shaped
          height: '35px', // Height equal to the desired width to make it square
        }}>
          <RiLoopLeftLine size={50}/>
        </IconButton>
    </Tooltip>
    </>
  );
}

function DeleteTabButton({index, handleDeleteEvent}) {
  const theme = useTheme();
  return (
    <>
    <Tooltip title="Delete button would delete the section and corresponding notes" size="md" arrow>
      <IconButton onClick={(e) => {
        e.preventDefault();
        handleDeleteEvent(index)}}
        style={{ 
            width: '35px', // Ensures the button is square-shaped
            height: '35px', // Height equal to the desired width to make it square
          }}
      >
          <DeleteIcon size={35}/>
        </IconButton>
    </Tooltip>
    </>
  );
}

function StepBackButton({index, handleStepBack}) {
  const theme = useTheme();
  return (
    <>
      <Tooltip key={"SBTT" + index} title="Move section back by 1 second" size="md" arrow>
        <IconButton
          key={"SBBTT" + index} 
          onClick={(e) => {
            e.preventDefault();
            handleStepBack(index)
          }}
          variant="contained"
          sx={{
            borderRadius: '4px', // Gives a slight rounded corner typical for rectangles
            width: 30, // Specifies the width of the button
            height: 35, // Specifies the height of the button
            padding: '4px' // Adjust padding to scale the icon appropriately
          }}
        >
          <IoIosArrowBack />
        </IconButton>
      </Tooltip>
    </>
  );
}

function StepForwardButton({index, handleStepForward}) {
  const theme = useTheme();
  return (
    <>
    <Tooltip key={"SFTT" + index} title="Move section forward by 1 second" size="md" arrow>
      <IconButton
        key={"SFTT" + index} 
        onClick={(e) => {
          e.preventDefault();
          handleStepForward(index)
        }}
        variant="contained"
        sx={{
          borderRadius: '4px', // Gives a slight rounded corner typical for rectangles
          width: 30, // Specifies the width of the button
          height: 35, // Specifies the height of the button
          padding: '4px' // Adjust padding to scale the icon appropriately
        }}>
          <IoIosArrowForward />
      </IconButton>
    </Tooltip>
    </>
  );
}

function MakeSectionHeader({bookmarks, index, onClick}) {
  const nextIndex = indexForNextOfType(
    bookmarks[index].type,
    bookmarks,
    index
  );
  return (
    <>
      <Typography variant="h5" onClick={onClick} fontWeight="bold">
        {bookmarks[index].text}
        {"  "}
        {getTimestampFromDuration(bookmarks[index].time)}
        {"   "}<FaArrowRight size={15} /> {"   "}
        {(nextIndex<bookmarks.length) ? // if because the last bookmark might not exist yet. It is only added when the player has excecuted it's ready event.
         getTimestampFromDuration(bookmarks[nextIndex].time): ""}
        {" "}
      </Typography>
    </>
  )
}

function SectionPaper({
  index, 
  bookmarks, 
  setBookmarks, 
  handleStartClick, 
  handleLoopClick, 
  handleDeleteEvent,
  handleStepBack,
  handleStepForward
}) {
  const theme = useTheme();
  const [editMode, setEditMode] = useState(false);
  const [editTitleMode, setEditTitleMode] = useState(false);
  const paperRef = useRef(null);
  const titleRef = useRef(null);

  const handleColorChange = (value) => { updateSection( bookmarks, setBookmarks, index, {color: value}) }
  const handleNotes = (value) => { updateSection( bookmarks, setBookmarks, index, {notes: value}) }

  useEffect(() => {
    function handleClickOutside(event) {
      if (paperRef.current && !paperRef.current.contains(event.target)) {
        setEditMode(false); // Set edit mode to false if click outside
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [paperRef]);

  useEffect(() => {
    if (editTitleMode) {
        titleRef.current.focus();
    }
  }, [editMode]);

  const handleBlur = () => {
    // When input loses focus, exit edit mode
    setEditTitleMode(false);
  };

  const handleTitleChange = (event) => {
    updateBookmarks(bookmarks, setBookmarks, index, {'text': event.target.value})
  };


  return <>
    <Paper style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
      <Grid container alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
        <Grid item xs={true} style={{ display: 'flex', alignItems: 'center' }}>
          <div onBlur={handleBlur}>
            {editTitleMode ? (
              <TextField
                variant="standard"
                value={bookmarks[index].text}
                onChange={handleTitleChange}
                inputRef={titleRef}
                onBlur={handleBlur}
                autoFocus
              />
            ) : (
              <MakeSectionHeader 
                bookmarks={bookmarks}
                index={index}
                onClick={() => setEditTitleMode(true)}
              />
            )}
          </div>
          { index > 0 && (
            <>
              <StepBackButton index={index} handleStepBack={handleStepBack}/>
              <StepForwardButton index={index} handleStepForward={handleStepForward}/>
            </>
          )}
        </Grid>
        <Grid item style={{display: 'flex', padding:2}}>
          <StartTabButton index={index} handleStartClick={handleStartClick}/>
          <LoopTabButton index={index} handleLoopClick={handleLoopClick}/>
          <DeleteTabButton index={index} handleDeleteEvent={handleDeleteEvent}/>
          <ThemeProvider theme={theme}>
            <Tooltip title="Highlight the section with different color" size="md" arrow>
              <ColorButton 
                buttonColor={bookmarks[index].color} 
                handleSetColor={handleColorChange}
                />
            </Tooltip>
          </ThemeProvider>
        </Grid>
      </Grid>
    </Paper>
    { editMode ? (
      <Paper 
        ref={paperRef}
        style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
        <ReactQuill theme="snow" value={bookmarks[index].notes} onChange={handleNotes} style={{width: '100%'}}/>
      </Paper>
    ) : ( (bookmarks[index].notes === "") ? (
          <Paper 
            ref={paperRef}
            onClick={() => setEditMode(true)}
            style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
            <Typography fontSize={14} style={{color: '#909090'}}> 
              (Click to add notes)
            </Typography>
          </Paper>
        ) : (
          <Paper 
            ref={paperRef}
            onClick={() => setEditMode(true)}
            style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
              <MDEditor.Markdown source={NodeHtmlMarkdown.translate(bookmarks[index].notes)} />
          </Paper>
        )
    )}
    </>
}


function QuotePaper({
  index, 
  bookmarks, 
  setBookmarks, 
  handleStartClick, 
  handleDeleteEvent,
}) {
  const theme = useTheme();
  const [editMode, setEditMode] = useState(false);
  const [editTitleMode, setEditTitleMode] = useState(false);
  const paperRef = useRef(null);
  const titleRef = useRef(null);

  const handleTimestampNotes = (value) => { updateTimestamp( bookmarks, setBookmarks, index, {notes: value}) }

  useEffect(() => {
    function handleClickOutside(event) {
      if (paperRef.current && !paperRef.current.contains(event.target)) {
        setEditMode(false); // Set edit mode to false if click outside
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [paperRef]);

  useEffect(() => {
    if (editTitleMode) {
        titleRef.current.focus();
    }
  }, [editMode]);

  const handleBlur = () => {
    // When input loses focus, exit edit mode
    setEditTitleMode(false);
  };

  const handleButtonClick = (e, index) => {
    e.stopPropagation();  // Prevents the event from bubbling up to the Paper component
    handleStartClick(index)
  };

  const handleQuoteChange = (event) => {
    updateBookmarks(bookmarks, setBookmarks, index, {'text': event.target.value})
  };

  return <>
    <Paper style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
      <Grid container alignItems="center" justifyContent="space-between" 
      style={{ width: '100%' }}>
        <Grid item >
          <Button variant="text" sx={{ marginRight: 2, flexShrink: 0 }}
              onClick={(e) => handleButtonClick(e, index)}>
              {getTimestampFromDuration(Math.round(bookmarks[index].time))}
          </Button>
        </Grid>
        <Grid item xs={true} style={{ display: 'flex', alignItems: 'left' }}>
            {editTitleMode ? (
              <TextField
                value={bookmarks[index].text}
                onChange={handleQuoteChange}
                inputRef={titleRef}
                onBlur={handleBlur}
                autoFocus
                maxRows={4}
                multiline
                fullWidth
              />
            ) : (
              <>
                <Typography onClick={() => setEditTitleMode(true)}>
                  {'"'}
                  {bookmarks[index].text}
                  {'"'}
                </Typography>
              </>
            )}
          {/* { index > 0 && (
            <>
              <StepBackButton handleStepBack={handleStepBack}/>
              <StepForwardButton handleStepForward={handleStepForward}/>
            </>
          )} */}
        </Grid>
        <Grid item style={{display: 'flex', padding:2}}>
          <DeleteTabButton index={index} handleDeleteEvent={handleDeleteEvent}/>
        </Grid>
      </Grid>
    </Paper>
    { editMode ? (
      <Paper 
        ref={paperRef}
        style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
        <ReactQuill theme="snow" value={bookmarks[index].notes} onChange={handleTimestampNotes} style={{width: '100%'}}/>
      </Paper>
    ) : ( (bookmarks[index].notes === "") ? (
          <Paper 
            ref={paperRef}
            onClick={() => setEditMode(true)}
            style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
              <Typography fontSize={14} style={{color: '#909090'}}> 
                (Click to add notes)
              </Typography>
          </Paper>
        ) : (
          <Paper 
            ref={paperRef}
            onClick={() => setEditMode(true)}
            style={{ padding: 16, display: 'flex', alignItems: 'center' }}>
              <MDEditor.Markdown source={NodeHtmlMarkdown.translate(bookmarks[index].notes)} />
          </Paper>
        )
    )}
    </>
}

export {SectionPaper, QuotePaper};
